import { render } from "./deptSelect.vue?vue&type=template&id=c01c8232&scoped=true"
import script from "./deptSelect.vue?vue&type=script&lang=js"
export * from "./deptSelect.vue?vue&type=script&lang=js"

import "./deptSelect.vue?vue&type=style&index=0&id=c01c8232&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01c8232"]])

export default __exports__